import { Helmet } from 'react-helmet-async';
// sections
import { ForRestaurantsView } from 'src/sections/for-restaurants/view';

// ----------------------------------------------------------------------

export default function ForRestaurantsPage() {
  return (
    <>
      <Helmet>
        <title>For Restaurants - Cartify</title>
      </Helmet>

      <ForRestaurantsView />
    </>
  );
}
